<template>
    <div v-if="server_questBody_c && selectedMapAreaIndex_n != null" class="TQ_center TQ_maxWidth_600px">


        <tq-polygons-map-missions :p_quest-body_c="server_questBody_c"
                                  :p_system_lang-code_e="store_system_langCode_v.val"

                                  :p_players-location_by-user-id_c="server_mapPlayersLocations_byUserId_c"
                                  :p_current-user-location_c="co_getCurrentUserLocation_c"
                                  :p_current-points_by-riddle-id_n="missionCurrentPoints_byRiddleId_n"
                                  :p_riddles-status_by-riddle-id_n="server_riddlesStatus_byRiddleId_c"
                                  :p_gst_missions-arrangement-index_n="server_gameStatus_c.gs_teams_byTeamId[store_currentTeamId_uid].gst_missionsArrangementIndex_n"

                                  :pe_click-mission_f="m_click_riddle_f"
                                  :pe_stop-watch-position_f="pe_startWatchPosition_f"
                                  :pe_start-watch-position_f="pe_stopWatchPosition_f"
        />


    </div>
</template>

<script>

    import {serverBig_questBody_once_fp} from "../../../scripts/Server/S_ServerFirestore";
    import {store_getStateValue_vo, store_var} from "../../../store";
    import TqImage from "../../../components/basic/TqImage";
    import TqLeafletDisplay from "../../../components/maps/TqLeafletDisplay";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqRiddleData from "../../../components/complex/TqRiddleData";
    import {
        serverOngoing_gameStatus_vl_remove_f,
        serverOngoing_gameStatus_vl_set_f, serverOngoing_teamPlayersGeoLocation_cl_remove_f,
        serverOngoing_teamPlayersGeoLocation_cl_set_f,
        serverOngoing_teamStatus_subCollection_cl_get_f, serverOngoing_teamStatus_vl_remove_f,
        serverOngoing_teamStatus_vl_set_f
    } from "../../../scripts/Server/S_ServerOngoing";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f,
        serverAuth_getOtherUserData_f
    } from "../../../scripts/Server/S_ServerAuth";
    import {route_moveToRoute} from "../../../router";
    import {enum_moveToOptions, enum_urlParams, enum_subCollection_teamStatus} from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqProgressBar from "../../../components/basic2/TqProgressBar";
    import TqPopup from "../../../components/basic/TqPopup";
    import TqOnTopContainer from "../../../components/basic/TqOnTopContainer";
    import TqStatingPointsBar from "../../../components/basic/tqStandingPointsBar";
    import TqPolygonsMapMissions from "../../../components/complex/TqPolygonsMapMissions";
    import {FB_MapPlayerLocation} from "@/classes/client_classes";

    export default {
        name: "V_Ongoing_PolygonsMap_List",
        components: {
            TqPolygonsMapMissions,
            TqStatingPointsBar,
            TqOnTopContainer,
            TqPopup, TqProgressBar, TqRiddleData, TqLoaderContainer, TqLeafletDisplay, TqImage},
        data(){
            return {
                selectedMapAreaIndex_n      : null,
                showMissionsGroupPopup_vb   : {val : false},
                selectedMissionGroupIndex_n : null,
                refreshMapCounter_n : 0,

                // helpers
                riddleIndex_byRiddleId_n : {},
                missionCurrentPoints_byRiddleId_n : {},

                // import
                ass_strings         : ass_strings,

                // store
                store_questEvent_c                : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid           : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_langCode_v           : store_getStateValue_vo(store_var.system_langCode),
                store_system_windowSizeType_ve    : store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_currentUserGeoLocation_vc   : store_getStateValue_vo(store_var.system_currentUserLocation),

                // server
                server_questBody_c                  : undefined,
                server_riddlesStatus_byRiddleId_c   : {},
                server_teamStatus_c                 : {},
                server_gameStatus_c                     : null,
                server_currentUserData_c                : null,
                server_mapPlayersLocations_byUserId_c   : {},
                server_teamsPlayersData_byPlayerIdC     : {},


            }
        },
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        },
        computed:{
            co_getCurrentUserLocation_c(){

                if(this.server_currentUserData_c.ud_userId_uid == null || this.store_currentUserGeoLocation_vc.val == null){
                    return null
                }

                return new FB_MapPlayerLocation({
                    mpl_userId_uid      : this.server_currentUserData_c.ud_userId_uid,
                    mpl_username_s      : null,
                    mpl_dotColor_s      : "#4285F4",
                    mpl_accuracy_n      : this.store_currentUserGeoLocation_vc.val.ugl_accuracy_n,
                    mpl_latitude_n      : this.store_currentUserGeoLocation_vc.val.ugl_latitude_n,
                    mpl_longitude_n     : this.store_currentUserGeoLocation_vc.val.ugl_longitude_n,
                    mpl_timestamp_t     : this.store_currentUserGeoLocation_vc.val.ugl_timestamp_t,
                    mpl_secondsForOld_n : 5,
                })

            },
            co_defaultMapAresOrderIndexes_an(){

                if(this.server_questBody_c == null){
                    return [0]
                }

                return this.server_questBody_c.qb_mapMissionsGroup_ac.map((val,index_n) => {return index_n})
            },
            co_mapAresOrderIndexes_an(){

                if(this.server_gameStatus_c == null || this.server_questBody_c == null){
                    return this.co_defaultMapAresOrderIndexes_an
                }

                let missionsArrangementIndex_n = this.server_gameStatus_c.gs_teams_byTeamId[this.store_currentTeamId_uid].gst_missionsArrangementIndex_n
                let currentTeam_missionsArrangement_c = this.server_questBody_c.qb_missionsArrangements_ac[missionsArrangementIndex_n]

                return currentTeam_missionsArrangement_c.qbma_groupsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.MAP_MISSIONS]
            },
        },
        methods: {
            m_click_riddle_f(riddleIndex_n){
                route_moveToRoute(enum_moveToOptions.ongoing_quest_openMapPolygons_riddle, {[enum_urlParams.riddleId_n]: riddleIndex_n})
            },
        },
        created() {

            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {
                this.server_currentUserData_c = currentUserData;
            })

            // 2) teamPlayerGeoLocations
            serverOngoing_teamPlayersGeoLocation_cl_set_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid,
                (userGeoLocation_c) => {

                    if( this.server_currentUserData_c != null &&
                        this.server_currentUserData_c.ud_userId_uid !== userGeoLocation_c.ugl_userId_uid){

                        // get user data
                        if(this.server_teamsPlayersData_byPlayerIdC[userGeoLocation_c.ugl_userId_uid] == null){

                            serverAuth_getOtherUserData_f(userGeoLocation_c.ugl_userId_uid,
                                userData_c => {
                                    this.$set(this.server_teamsPlayersData_byPlayerIdC, userGeoLocation_c.ugl_userId_uid, userData_c)
                                })

                        }else{


                            this.$set(this.server_mapPlayersLocations_byUserId_c, userGeoLocation_c.ugl_userId_uid, new FB_MapPlayerLocation({
                                mpl_userId_uid      : userGeoLocation_c.ugl_userId_uid,
                                mpl_username_s      : this.server_teamsPlayersData_byPlayerIdC[userGeoLocation_c.ugl_userId_uid].ud_name_s,
                                mpl_dotColor_s      : "green",
                                mpl_accuracy_n      : userGeoLocation_c.ugl_accuracy_n,
                                mpl_latitude_n      : userGeoLocation_c.ugl_latitude_n,
                                mpl_longitude_n     : userGeoLocation_c.ugl_longitude_n,
                                mpl_timestamp_t     : userGeoLocation_c.ugl_timestamp_t,
                                mpl_secondsForOld_n : 5,
                            }))
                        }
                    }
                })

            // 3) get questBody
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true, (questBody_c)=>{
                this.server_questBody_c = questBody_c

                // riddles indexes by riddle id
                this.server_questBody_c.qb_mapMissions_ac.forEach((qb_riddle_c, index_n) => {
                    this.riddleIndex_byRiddleId_n[qb_riddle_c.qbr_riddleId_n] = index_n
                })

                // get teamStatus subCollection riddles
                serverOngoing_teamStatus_subCollection_cl_get_f({
                    viewName_s          : this.$options.name,
                    subCollectionName_e : enum_subCollection_teamStatus.MAP_MISSIONS,
                    questEvent_c        : this.store_questEvent_c,
                    teamId_uid          : this.store_currentTeamId_uid,
                    cb_ChildAdded_f : (riddleStatus_c) => {

                        let score_n = riddleStatus_c.cm_rs_locksTotalPoints_n()

                        this.$set(this.missionCurrentPoints_byRiddleId_n, riddleStatus_c.rs_riddleId_n, score_n)
                        this.$set(this.server_riddlesStatus_byRiddleId_c, riddleStatus_c.rs_riddleId_n, riddleStatus_c)

                    },
                })
            })

            // 4) get teamStatus
            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_questEvent_c, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c
                }
            })

            // 4) get gameStatus
            serverOngoing_gameStatus_vl_set_f(
                this.$options.name,
                this.store_questEvent_c.qev_questType_e,
                this.store_questEvent_c.qev_questId_uid,
                this.store_questEvent_c.qev_eventId_uid,
                true,
                (gameStatus_c) => {
                    this.server_gameStatus_c = gameStatus_c;
                    this.selectedMapAreaIndex_n= this.co_mapAresOrderIndexes_an[0]
                })
        },
        destroyed() {

            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            serverOngoing_teamPlayersGeoLocation_cl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)

            serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)

            serverOngoing_gameStatus_vl_remove_f(this.$options.name, this.store_questEvent_c)
        }
    }
</script>

<style scoped>

    .lc_pointsLabel{
        margin-bottom: 8px;
        border-top: 1px solid white;
        border-left: 1px solid white;
        border-bottom: 1px solid white;
        border-radius: 4px 0 0 8px;
    }

    .lc_pointsBar{
        position: absolute;
        top: 40px;
        left: 0;
    }

</style>